import { useTranslation } from 'react-i18next';

import { ISettlements } from '@/modules/Settlements/types';
import { SummaryCard } from '@/modules/workingDayReconciliation';

import Dollar from '~/images/shared/dollar-circle.svg';
import DollarUpperArrow from '~/images/shared/DollarUpperArrow.svg';
import MoneyChecked from '~/images/shared/MoneyChecked.svg';

const Summary: React.FC<ISettlements.IGetWorkerSettlementSummary> = ({
  settlementsTotalAmount,
  issuedSettlementsTotalAmount,
  underIssuanceSettlementsTotalAmount,
}) => {
  const { t } = useTranslation('common');

  return (
    <div className='mb-16 flex w-full justify-evenly gap-16'>
      <SummaryCard
        subTitle={t('total-settlements')}
        number={settlementsTotalAmount}
        icon={<Dollar />}
        showCurrency
        info={t('total-settlement-info')}
      />
      <SummaryCard
        subTitle={t('total-created')}
        number={underIssuanceSettlementsTotalAmount}
        icon={<DollarUpperArrow />}
        showCurrency
        info={t('total-created-info')}
      />
      <SummaryCard
        subTitle={t('total-issued')}
        number={issuedSettlementsTotalAmount}
        icon={<MoneyChecked />}
        showCurrency
        info={t('total-issued-info')}
      />
    </div>
  );
};

export { Summary };
